import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '../styles/theme';

const tipoColori = {
  aggiornamento: '#7c3aed',
  best_product: '#fbbf24',
  guida: '#4ade80',
  upgrade: '#7c3aed',
  ebay: '#22d3ee',
  corso: '#a78bfa',
  ticket: '#f87171',
  promemoria: '#fbbf24',
  scadenza: '#f87171',
};

function tempoRelativo(dateStr) {
  if (!dateStr) return '';
  const now = new Date();
  const d = new Date(dateStr.replace(' ', 'T') + (dateStr.includes('Z') ? '' : 'Z'));
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return 'ora';
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ore fa`;
  if (diff < 172800) return 'ieri';
  if (diff < 604800) return `${Math.floor(diff / 86400)} giorni fa`;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
}

export default function NotificheCampanella({ notifiche, nonLette, segnaLetta, leggiTutte }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleClick = (n) => {
    if (!n.letta) segnaLetta(n.id);
    if (n.link) navigate(n.link);
    setOpen(false);
  };

  const handleLeggiTutte = () => {
    leggiTutte();
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Campanella */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: 'relative', background: 'none', border: 'none', cursor: 'pointer',
          color: T.muted, padding: 6, borderRadius: 8, transition: '0.2s',
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = T.violet}
        onMouseLeave={(e) => e.currentTarget.style.color = T.muted}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
        </svg>
        {nonLette > 0 && (
          <span style={{
            position: 'absolute', top: 0, right: 0,
            width: 18, height: 18, borderRadius: '50%',
            background: T.red, color: '#fff',
            fontSize: '0.68rem', fontWeight: 700, fontFamily: T.fontBody,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            animation: 'pulse 2s ease-in-out infinite',
            border: `2px solid ${T.bg}`,
          }}>{nonLette > 9 ? '9+' : nonLette}</span>
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div style={{
          position: window.innerWidth < 768 ? 'fixed' : 'absolute',
          top: window.innerWidth < 768 ? 60 : '100%',
          right: window.innerWidth < 768 ? 16 : 0,
          left: window.innerWidth < 768 ? 16 : 'auto',
          marginTop: window.innerWidth < 768 ? 0 : 8,
          width: window.innerWidth < 768 ? 'auto' : 360,
          maxHeight: 460, backgroundColor: T.card,
          border: `1px solid ${T.border}`, borderRadius: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
          zIndex: 1000, display: 'flex', flexDirection: 'column',
          overflow: 'hidden',
        }}>
          {/* Header */}
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 16px', borderBottom: `1px solid ${T.border}`,
          }}>
            <span style={{ fontFamily: T.fontDisplay, fontWeight: 700, fontSize: '0.95rem', color: T.text }}>
              Notifiche
            </span>
            {nonLette > 0 && (
              <button onClick={handleLeggiTutte} style={{
                background: 'rgba(124,58,237,0.15)', border: `1px solid rgba(124,58,237,0.3)`,
                color: T.violet, padding: '4px 10px', borderRadius: 8,
                fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer',
                fontFamily: T.fontBody, transition: '0.2s',
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(124,58,237,0.25)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(124,58,237,0.15)'}
              >Leggi tutte</button>
            )}
          </div>

          {/* Lista */}
          <div style={{ flex: 1, overflowY: 'auto', maxHeight: 400 }}>
            {notifiche.length === 0 ? (
              <div style={{ padding: 32, textAlign: 'center' }}>
                <div style={{ fontSize: '2rem', marginBottom: 8 }}>✅</div>
                <p style={{ color: T.muted, fontSize: '0.85rem', fontFamily: T.fontBody, margin: 0 }}>
                  Nessuna notifica — sei aggiornato!
                </p>
              </div>
            ) : (
              notifiche.map((n) => {
                const isLetta = !!n.letta;
                const colore = tipoColori[n.tipo] || T.violet;
                return (
                  <div key={n.id}
                    onClick={() => handleClick(n)}
                    style={{
                      display: 'flex', alignItems: 'flex-start', gap: 12,
                      padding: '12px 16px', cursor: 'pointer',
                      borderBottom: `1px solid rgba(45,31,110,0.3)`,
                      background: isLetta ? 'rgba(13,11,30,0.4)' : T.card,
                      transition: '0.15s',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = T.elem}
                    onMouseLeave={(e) => e.currentTarget.style.background = isLetta ? 'rgba(13,11,30,0.4)' : T.card}
                  >
                    {/* Punto non letto */}
                    {!isLetta && (
                      <div style={{
                        width: 8, height: 8, borderRadius: '50%', background: T.violet,
                        marginTop: 6, flexShrink: 0,
                      }} />
                    )}
                    {isLetta && <div style={{ width: 8, flexShrink: 0 }} />}

                    {/* Icona tipo */}
                    <div style={{
                      width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                      background: `${colore}20`, display: 'flex',
                      alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
                    }}>
                      {n.icona || '🔔'}
                    </div>

                    {/* Contenuto */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <p style={{
                        margin: 0, fontSize: '0.83rem', fontWeight: isLetta ? 400 : 600,
                        color: isLetta ? T.muted : T.text, fontFamily: T.fontBody,
                        lineHeight: 1.4,
                      }}>{n.titolo}</p>
                      {n.messaggio && (
                        <p style={{
                          margin: '2px 0 0', fontSize: '0.75rem', color: T.muted,
                          fontFamily: T.fontBody, lineHeight: 1.3,
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}>{n.messaggio}</p>
                      )}
                      <span style={{ fontSize: '0.68rem', color: T.faint, fontFamily: T.fontBody }}>
                        {tempoRelativo(n.created_at)}
                      </span>
                    </div>

                    {/* Bottone segna letta */}
                    {!isLetta && (
                      <button
                        onClick={(e) => { e.stopPropagation(); segnaLetta(n.id); }}
                        style={{
                          background: 'none', border: 'none', color: T.muted,
                          cursor: 'pointer', padding: 4, borderRadius: 6, flexShrink: 0,
                          marginTop: 2, transition: '0.2s',
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.color = T.green}
                        onMouseLeave={(e) => e.currentTarget.style.color = T.muted}
                        title="Segna come letta"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </button>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
      `}</style>
    </div>
  );
}
